
import React from 'react';
import Layout from '@/components/Layout/Layout';
import DigitalStorageConverter from '@/components/UnitConverter/DigitalStorageConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const DigitalStorageConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2 font-bold">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Digital Storage Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different digital storage units, from bytes to terabytes and more.
          </p>
        </div>
        
        <div className="mb-8">
          <DigitalStorageConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Digital Storage Converter</h2>
          <p>
            Our digital storage converter tool will help you convert between different units of digital storage.
            Whether you're working with bytes, kilobytes, megabytes, gigabytes, or terabytes, this converter will
            provide accurate and quick unit conversions for all your computing and storage needs.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Coming Soon</h3>
          <p>
            We're currently developing this feature to support a wide range of digital storage units for all your
            conversion needs. Check back soon for the complete functionality!
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default DigitalStorageConverterPage;
